(function () {
  document.documentElement.classList.remove('no-js');

  /*
    Safari n'autorise l'autoplay qu'une fois la vidéo explicitement muette
    et inline. On réapplique ces propriétés avant chaque lecture, y compris
    après un retour d'onglet ou de bfcache.
  */
  var prepareHeroAutoplay = function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  };

  var isHeroVideoVisible = function (video) {
    var rect = video.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  var resumeHeroPlayback = function (video) {
    prepareHeroAutoplay(video);
    if (!video.paused || !isHeroVideoVisible(video)) return;
    var playing = video.play();
    if (playing && playing.catch) {
      playing.catch(function () {
        video.dataset.heroAutoplay = 'blocked';
      });
    }
  };

  document.querySelectorAll('.collection-hero__video').forEach(function (video) {
    prepareHeroAutoplay(video);
    video.addEventListener('loadeddata', function () {
      resumeHeroPlayback(video);
    }, { once: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) resumeHeroPlayback(video);
        });
      }, { threshold: 0.05 }).observe(video);
    }
    video.addEventListener('pause', function () {
      if (isHeroVideoVisible(video)) resumeHeroPlayback(video);
    });
    resumeHeroPlayback(video);
  });

  /* Retour bfcache : Safari peut restaurer le hero en pause. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('.collection-hero__video').forEach(function (video) {
      prepareHeroAutoplay(video);
      video.load();
      resumeHeroPlayback(video);
    });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    document.querySelectorAll('.collection-hero__video').forEach(resumeHeroPlayback);
  });

  var siteHeaderEl = document.querySelector('.site-header');
  var setSiteHeaderHeightVar = function () {
    if (siteHeaderEl) {
      document.documentElement.style.setProperty('--site-header-height', siteHeaderEl.offsetHeight + 'px');
    }
  };
  setSiteHeaderHeightVar();
  window.addEventListener('resize', setSiteHeaderHeightVar);

  /*
    En mobile, le sélecteur de catégories et les étapes du configurateur sont
    tous les deux sticky. La hauteur réelle du sélecteur change quand sa liste
    est ouverte ou quand l'alerte « aucun produit » apparaît : on la publie
    donc pour que les étapes restent toujours juste en dessous.
  */
  var corporateCategoryStripEl = document.querySelector('.corporate-category-strip');
  var setCorporateCategoryStripHeightVar = function () {
    if (corporateCategoryStripEl) {
      document.documentElement.style.setProperty('--corporate-category-strip-height', corporateCategoryStripEl.offsetHeight + 'px');
    }
  };
  if (corporateCategoryStripEl) {
    setCorporateCategoryStripHeightVar();
    window.addEventListener('resize', setCorporateCategoryStripHeightVar);

    var corporateCategorySelectEl = corporateCategoryStripEl.querySelector('[data-corporate-category-select]');
    if (corporateCategorySelectEl) {
      corporateCategorySelectEl.addEventListener('toggle', function () {
        window.requestAnimationFrame(setCorporateCategoryStripHeightVar);
      });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(setCorporateCategoryStripHeightVar).observe(corporateCategoryStripEl);
    }
  }

  if (document.querySelector('.collection-hero--image-only')) {
    document.body.classList.add('has-transparent-header');
    var updateHeaderScrollState = function () {
      document.body.classList.toggle('is-header-scrolled', window.scrollY > 24);
    };
    updateHeaderScrollState();
    window.addEventListener('scroll', updateHeaderScrollState, { passive: true });
  }

  /*
    Formulaire « Nous contacter » : si un endpoint formulaire web FastEvent est
    configuré sur la section, la soumission part en JSON vers FastEvent (lead
    CRM + e-mail) au lieu du formulaire natif Shopify.
  */
  (function () {
    var contactForm = document.querySelector('#CorporateContactForm');
    var endpointInput = contactForm && contactForm.querySelector('[data-fastevent-form-endpoint]');
    if (!contactForm || !endpointInput || !endpointInput.value) return;

    var startedAt = Date.now();
    var statusMessage = contactForm.querySelector('[data-fastevent-form-message]');
    var fieldMap = {
      'contact[name]': 'contact_name',
      'contact[email]': 'contact_email',
      'contact[company]': 'contact_company',
      'contact[siret]': 'contact_siret',
      'contact[phone]': 'contact_phone',
      'contact[body]': 'contact_message'
    };

    var showStatus = function (text, tone) {
      if (!statusMessage) return;
      statusMessage.textContent = text;
      statusMessage.dataset.tone = tone || '';
      statusMessage.hidden = !text;
    };

    contactForm.addEventListener('submit', function (event) {
      event.preventDefault();

      var payload = { _fe_started_at: startedAt };
      Object.keys(fieldMap).forEach(function (inputName) {
        var input = contactForm.querySelector('[name="' + inputName + '"]');
        if (input && input.value) payload[fieldMap[inputName]] = input.value;
      });
      var honeypot = contactForm.querySelector('[name="website_url"]');
      if (honeypot && honeypot.value) payload.website_url = honeypot.value;

      var submitButton = contactForm.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      showStatus('Envoi en cours…', '');

      fetch(endpointInput.value, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) throw new Error(data.error || 'envoi impossible');
            return data;
          });
        })
        .then(function (data) {
          showStatus(data.message || 'Votre message a bien été envoyé.', 'success');
          contactForm.reset();
        })
        .catch(function (error) {
          showStatus("L'envoi a échoué : " + error.message + '. Réessayez ou écrivez-nous directement.', 'error');
        })
        .then(function () {
          if (submitButton) submitButton.disabled = false;
        });
    });
  })();

  var cartToastTimer = null;

  function getCartToast() {
    var toast = document.querySelector('[data-cart-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('data-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.hidden = true;
    document.body.appendChild(toast);
    return toast;
  }

  function showCartToast(message, tone) {
    var toast = getCartToast();
    window.clearTimeout(cartToastTimer);
    toast.textContent = message;
    toast.dataset.tone = tone || '';
    toast.hidden = false;

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    cartToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        toast.hidden = true;
      }, 220);
    }, 3200);
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (counter) {
          counter.textContent = cart.item_count;
        });
      });
  }

  var drawer = document.querySelector('[data-drawer]');
  var drawerOpen = document.querySelector('[data-drawer-open]');
  var drawerCloseButtons = document.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      document.body.classList.add('drawer-open');
      if (drawerOpen) drawerOpen.setAttribute('aria-expanded', 'true');
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    if (drawerOpen) drawerOpen.setAttribute('aria-expanded', 'false');
    window.setTimeout(function () {
      drawer.hidden = true;
    }, 250);
  }

  if (drawerOpen) drawerOpen.addEventListener('click', openDrawer);
  drawerCloseButtons.forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
    var index = 0;
    if (slides.length < 2) return;

    function show(next) {
      index = next % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        show(dotIndex);
      });
    });

    window.setInterval(function () {
      show(index + 1);
    }, 6500);
  });

  document.querySelectorAll('[data-quantity-control]').forEach(function (control) {
    var input = control.querySelector('input[type="number"]');
    var minus = control.querySelector('[data-quantity-minus]');
    var plus = control.querySelector('[data-quantity-plus]');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        input.value = Math.max(1, Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = Number(input.value || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var select = section.querySelector('[data-variant-select]');
    var price = section.querySelector('[data-product-price] .price__current');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var button = section.querySelector('[data-add-to-cart]');
    var sticky = section.querySelector('[data-sticky-atc]');
    var scrollButton = section.querySelector('[data-scroll-to-product-form]');
    var form = section.querySelector('.product-form');

    if (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var nextPrice = option.getAttribute('data-price');
        var available = option.getAttribute('data-available') === 'true';
        if (price && nextPrice) price.textContent = nextPrice;
        if (stickyPrice && nextPrice) stickyPrice.textContent = nextPrice;
        if (button) {
          button.disabled = !available;
          button.textContent = available ? button.dataset.availableText || 'Ajouter au panier' : button.dataset.soldOutText || 'Épuisé';
        }
      });
    }

    if (sticky && form && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(form);
    }

    if (scrollButton && form) {
      scrollButton.addEventListener('click', function () {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });

  /*
    Champs d'adresse (header + menu mobile) : ils étaient purement décoratifs.
    Ils proposent maintenant une autocomplétion sur la Base Adresse Nationale
    (api-adresse.data.gouv.fr), la même source que FastEvent — service public,
    sans clé ni quota. L'adresse choisie est mémorisée pour être réaffichée à
    la visite suivante et reprise par « Mon adresse ».
  */
  var ADDRESS_API_URL = 'https://data.geopf.fr/geocodage/search/';
  var ADDRESS_STORAGE_KEY = 'becchi-delivery-address';
  var ADDRESS_MIN_CHARS = 3;
  var ADDRESS_DEBOUNCE_MS = 650;
  var ADDRESS_MIN_REQUEST_INTERVAL_MS = 1100;
  var lastAddressRequestTimestamp = 0;

  function readStoredAddress() {
    try {
      return window.localStorage.getItem(ADDRESS_STORAGE_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function storeAddress(value) {
    try {
      window.localStorage.setItem(ADDRESS_STORAGE_KEY, value);
    } catch (error) {
      /* Navigation privée : on garde simplement l'adresse pour la session. */
    }
  }

  document.querySelectorAll('[data-address-visual]').forEach(function (addressVisual, addressIndex) {
    addressVisual.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    var input = addressVisual.querySelector('input[type="text"]');
    if (!input) return;

    var confirmButton = addressVisual.querySelector('button');
    var results = document.createElement('ul');
    results.className = 'address-suggestions';
    results.id = 'AddressSuggestions' + addressIndex;
    results.setAttribute('role', 'listbox');
    results.setAttribute('aria-live', 'polite');
    results.hidden = true;
    addressVisual.appendChild(results);

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-expanded', 'false');

    var stored = readStoredAddress();
    if (stored && !input.value) input.value = stored;

    var debounceTimer = null;
    var requestId = 0;

    function requestSuggestions(query, currentRequestId) {
      var elapsed = Date.now() - lastAddressRequestTimestamp;
      var waitTime = Math.max(0, ADDRESS_MIN_REQUEST_INTERVAL_MS - elapsed);

      window.setTimeout(function () {
        if (currentRequestId !== requestId) return;

        lastAddressRequestTimestamp = Date.now();
        fetch(ADDRESS_API_URL + '?q=' + encodeURIComponent(query) + '&limit=5')
          .then(function (response) {
            if (!response.ok) throw new Error('adresse');
            return response.json();
          })
          .then(function (data) {
            /* Une réponse plus ancienne ne doit jamais écraser la plus récente. */
            if (currentRequestId !== requestId) return;
            renderSuggestions((data && data.features) || []);
          })
          .catch(function () {
            if (currentRequestId === requestId) {
              renderMessage('La recherche d’adresse est indisponible. Réessayez dans un instant.', true);
            }
          });
      }, waitTime);
    }

    function closeSuggestions() {
      /*
        On invalide la requête en vol : sans ça, une réponse tardive rouvrait
        la liste après que le visiteur a effacé le champ, appuyé sur Échap,
        cliqué ailleurs ou déjà choisi une adresse.
      */
      requestId++;
      window.clearTimeout(debounceTimer);
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function selectAddress(label) {
      input.value = label;
      storeAddress(label);
      closeSuggestions();
    }

    function renderSuggestions(features) {
      results.innerHTML = '';
      if (features.length === 0) {
        renderMessage('Aucune adresse trouvée. Vérifiez la rue, le code postal ou la ville.');
        return;
      }
      features.forEach(function (feature) {
        var label = feature && feature.properties && feature.properties.label;
        if (!label) return;
        var item = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'address-suggestions__item';
        button.setAttribute('role', 'option');
        button.textContent = label;
        button.addEventListener('click', function () {
          selectAddress(label);
        });
        item.appendChild(button);
        results.appendChild(item);
      });
      results.hidden = results.children.length === 0;
      input.setAttribute('aria-expanded', results.hidden ? 'false' : 'true');
    }

    function renderMessage(message, isError) {
      results.innerHTML = '';
      var item = document.createElement('li');
      item.className = 'address-suggestions__status' + (isError ? ' is-error' : '');
      item.textContent = message;
      results.appendChild(item);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(debounceTimer);
      var current = ++requestId;
      if (query.length < ADDRESS_MIN_CHARS) {
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
        return;
      }
      renderMessage('Recherche des adresses…');
      debounceTimer = window.setTimeout(function () {
        requestSuggestions(query, current);
      }, ADDRESS_DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSuggestions();
    });

    if (confirmButton) {
      confirmButton.addEventListener('click', function () {
        var value = input.value.trim();
        if (value) storeAddress(value);
        closeSuggestions();
      });
    }

    document.addEventListener('click', function (event) {
      if (!addressVisual.contains(event.target)) closeSuggestions();
    });
  });

  var corporateFilterAliases = {
    'petit-dej': ['petit-dej', 'petit-dejeuner', 'petit-déjeuner', 'breakfast'],
    'repas-equipe': ['repas-dequipe', 'repas-d-equipe', 'repas-equipe'],
    'plateaux-repas': ['plateau-repas', 'plateaux-repas', 'coffret-repas', 'coffret', 'lunchbox', 'sandwich-box', 'sandwichbox'],
    'formats-partager': ['buffet', 'buffets', 'format-a-partager', 'formats-a-partager', 'grand-plat', 'planche', 'assiette', 'mini-sandwich', 'biscuit', 'dolci', 'tiramisu', 'cookie', 'fruit', 'dessert'],
    cocktail: ['cocktail', 'mini-pinsa', 'mini-club', 'verrine', 'brochette'],
    'compositions-becchi': ['composition', 'compositions', 'pack-classique', 'pack-signature'],
    animations: ['bar-a', 'pasta-dans', 'decoupe-du-jambon', 'chariot', 'animation'],
    boissons: ['boisson', 'boissons', 'soft', 'jus', 'eau-plate', 'eau-gazeuse', 'limonade', 'biere', 'vin', 'champagne', 'prosecco', 'cocktail-argotier'],
    services: ['maitre', 'location', 'livraison', 'service'],
    'upsell-non-food': ['couvert', 'couverts', 'bambou', 'inox', 'nappage', 'vaisselle', 'serviette', 'livraison', 'location']
  };

  function productMatchesCorporateFilter(card, filter) {
    var haystack = card.getAttribute('data-product-tags') || '';
    var tokens = corporateFilterAliases[filter] || [filter];
    return tokens.some(function (token) {
      return haystack.indexOf(token) !== -1;
    });
  }

  var corporateGridHydrationPromise = null;
  var corporateFilterRequestId = 0;

  function getCorporateCards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
  }

  function getCorporatePageKey(url) {
    try {
      var parsed = new URL(url, window.location.href);
      parsed.searchParams.delete('clf');
      parsed.searchParams.delete('cachebust');
      return parsed.pathname + '?' + parsed.searchParams.toString();
    } catch (error) {
      return String(url || '');
    }
  }

  function getCorporatePaginationUrls(root) {
    var seen = {};
    return Array.prototype.slice.call(root.querySelectorAll('.pagination a[href]')).map(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return null;
        url.searchParams.delete('clf');
        url.searchParams.delete('cachebust');
        return url.toString();
      } catch (error) {
        return null;
      }
    }).filter(function (url) {
      if (!url) return false;
      var key = getCorporatePageKey(url);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function appendCorporateCardsFromDocument(doc) {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;

    var existing = {};
    getCorporateCards().forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (id) existing[id] = true;
    });

    var activeFilter = document.documentElement.getAttribute('data-corporate-filter');
    Array.prototype.slice.call(doc.querySelectorAll('.product-grid [data-product-card]')).forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      if (id && existing[id]) return;
      if (id) existing[id] = true;
      var imported = document.importNode(card, true);
      if (activeFilter) imported.hidden = !productMatchesCorporateFilter(imported, activeFilter);
      grid.appendChild(imported);
    });
  }

  function hydrateCorporateCollectionGrid() {
    var grid = document.querySelector('.product-grid');
    if (!grid || grid.getAttribute('data-corporate-grid-hydrated') === 'true') {
      return Promise.resolve(getCorporateCards());
    }
    if (corporateGridHydrationPromise) return corporateGridHydrationPromise;

    var parser = new DOMParser();
    var visited = {};
    var queue = getCorporatePaginationUrls(document);
    visited[getCorporatePageKey(window.location.href)] = true;

    corporateGridHydrationPromise = new Promise(function (resolve) {
      function next() {
        var url = queue.shift();
        if (!url) {
          grid.setAttribute('data-corporate-grid-hydrated', 'true');
          resolve(getCorporateCards());
          return;
        }

        var key = getCorporatePageKey(url);
        if (visited[key]) {
          next();
          return;
        }
        visited[key] = true;

        fetch(url, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('collection page');
            return response.text();
          })
          .then(function (html) {
            var doc = parser.parseFromString(html, 'text/html');
            appendCorporateCardsFromDocument(doc);
            getCorporatePaginationUrls(doc).forEach(function (nextUrl) {
              if (!visited[getCorporatePageKey(nextUrl)]) queue.push(nextUrl);
            });
          })
          .catch(function () {
            // Keep the current page usable if a paginated fetch fails.
          })
          .then(next);
      }

      next();
    }).then(function (cards) {
      corporateGridHydrationPromise = null;
      return cards;
    });

    return corporateGridHydrationPromise;
  }

  function setCorporateCategoryStatus(status, visible) {
    if (!status) return;
    status.hidden = !visible;
    var strip = status.closest('.corporate-category-strip');
    if (strip) strip.classList.toggle('has-status', visible);
    window.requestAnimationFrame(setCorporateCategoryStripHeightVar);
  }

  function updateCorporateCollectionCount(count) {
    var countNode = document.querySelector('.collection-toolbar > p');
    if (!countNode) return;
    if (!countNode.getAttribute('data-original-text')) {
      countNode.setAttribute('data-original-text', countNode.textContent || '');
    }
    countNode.textContent = count + ' produit' + (count > 1 ? 's' : '');
  }

  /*
    TEMP BECCHI PLATEAUX DEMO NERF:
    This injects two large chooser cards for Plateaux Repas so the demo visibly
    separates Coffret Repas and Sandwich Box. Product data and product cards stay
    unchanged. Rollback: delete this marked JS block, the matching marked CSS block,
    and the HTML comment in sections/main-collection.liquid.
  */
  var corporatePlateauxDemoGroups = [
    {
      key: 'coffret-repas',
      label: 'Coffret Repas',
      eyebrow: 'Formule complète',
      text: 'Entrée, plat et dessert pour les réunions importantes et les déjeuners clients.',
      price: '21 € HT / personne',
      tokens: ['coffret-repas']
    },
    {
      key: 'sandwich-box',
      label: 'Sandwich Box',
      eyebrow: 'Format rapide',
      text: 'Entrée, sandwich et dessert pour les déjeuners d’équipe et les formats rapides.',
      price: '20 € HT / personne',
      tokens: ['sandwich-box', 'sandwichbox']
    }
  ];

  function productMatchesTokens(card, tokens) {
    var haystack = card.getAttribute('data-product-tags') || '';
    return tokens.some(function (token) {
      return haystack.indexOf(token) !== -1;
    });
  }

  function removePlateauxDemoChooser() {
    var chooser = document.querySelector('[data-plateaux-demo-chooser]');
    if (chooser) chooser.hidden = true;
  }

  function isCorporateMobileLayout() {
    return window.matchMedia && window.matchMedia('(max-width: 900px)').matches;
  }

  function getPlateauxDemoMountPoint() {
    var grid = document.querySelector('.product-grid');
    var mobileSlot = document.querySelector('[data-plateaux-demo-mobile-slot]');

    if (isCorporateMobileLayout() && mobileSlot) {
      return { parent: mobileSlot, before: null };
    }

    if (!grid || !grid.parentNode) return null;
    return { parent: grid.parentNode, before: grid };
  }

  function mountPlateauxDemoChooser(chooser) {
    var mount = getPlateauxDemoMountPoint();
    if (!chooser || !mount) return;

    chooser.classList.toggle('plateaux-demo-chooser--with-filters', !isCorporateMobileLayout() && Boolean(document.querySelector('.collection-filters')));

    if (mount.before) {
      if (chooser.parentNode !== mount.parent || chooser.nextSibling !== mount.before) {
        mount.parent.insertBefore(chooser, mount.before);
      }
      return;
    }

    if (chooser.parentNode !== mount.parent) {
      mount.parent.appendChild(chooser);
    }
  }

  function ensurePlateauxDemoChooser(cards) {
    var grid = document.querySelector('.product-grid');
    if (!grid) return null;

    var existing = document.querySelector('[data-plateaux-demo-chooser]');
    if (existing) {
      existing.hidden = false;
      mountPlateauxDemoChooser(existing);
      return existing;
    }

    var chooser = document.createElement('section');
    chooser.className = 'plateaux-demo-chooser';
    chooser.setAttribute('data-plateaux-demo-chooser', '');
    chooser.setAttribute('aria-label', 'Choisir une section Plateaux Repas');

    var comment = document.createComment(' TEMP BECCHI PLATEAUX DEMO NERF: two-card chooser injected by assets/theme.js. Rollback instructions are in sections/main-collection.liquid. ');
    grid.parentNode.insertBefore(comment, grid);

    var header = document.createElement('div');
    header.className = 'plateaux-demo-chooser__header';
    header.innerHTML = '<p>Plateaux Repas</p><h2>Coffret Repas ou Sandwich Box</h2>';
    chooser.appendChild(header);

    var gridEl = document.createElement('div');
    gridEl.className = 'plateaux-demo-chooser__grid';
    chooser.appendChild(gridEl);

    corporatePlateauxDemoGroups.forEach(function (group) {
      var count = cards.filter(function (card) {
        return productMatchesTokens(card, group.tokens);
      }).length;
      var button = document.createElement('button');
      button.className = 'plateaux-demo-chooser__card';
      button.type = 'button';
      button.setAttribute('data-plateaux-demo-group', group.key);
      button.innerHTML =
        '<span class="plateaux-demo-chooser__eyebrow">' + group.eyebrow + '</span>' +
        '<strong>' + group.label + '</strong>' +
        '<span class="plateaux-demo-chooser__text">' + group.text + '</span>' +
        '<span class="plateaux-demo-chooser__meta"><span data-plateaux-demo-count>' + count + ' produits</span><span>' + group.price + '</span></span>';
      gridEl.appendChild(button);
    });

    var allButton = document.createElement('button');
    allButton.className = 'plateaux-demo-chooser__all is-active';
    allButton.type = 'button';
    allButton.setAttribute('data-plateaux-demo-group', 'all');
    allButton.textContent = 'Voir les deux sections';
    chooser.appendChild(allButton);
    mountPlateauxDemoChooser(chooser);

    return chooser;
  }

  function updatePlateauxDemoChooser(cards, activeGroup) {
    var chooser = ensurePlateauxDemoChooser(cards);
    if (!chooser) return;

    corporatePlateauxDemoGroups.forEach(function (group) {
      var button = chooser.querySelector('[data-plateaux-demo-group="' + group.key + '"]');
      if (!button) return;
      var count = cards.filter(function (card) {
        return productMatchesTokens(card, group.tokens);
      }).length;
      var countNode = button.querySelector('[data-plateaux-demo-count]');
      if (countNode) countNode.textContent = count + ' produits';
      button.classList.toggle('is-active', activeGroup === group.key);
    });

    var allButton = chooser.querySelector('[data-plateaux-demo-group="all"]');
    if (allButton) allButton.classList.toggle('is-active', !activeGroup || activeGroup === 'all');
  }

  function applyPlateauxDemoGroup(groupKey, scrollToGrid) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
    var status = document.querySelector('[data-corporate-category-status]');
    var plateauxCards = cards.filter(function (card) {
      return productMatchesCorporateFilter(card, 'plateaux-repas');
    });
    var activeGroup = groupKey || 'all';
    var group = corporatePlateauxDemoGroups.find(function (item) {
      return item.key === activeGroup;
    });
    var visibleCards = group ? plateauxCards.filter(function (card) {
      return productMatchesTokens(card, group.tokens);
    }) : plateauxCards;

    updatePlateauxDemoChooser(plateauxCards, activeGroup);
    cards.forEach(function (card) {
      card.hidden = visibleCards.indexOf(card) === -1;
    });
    setCorporateCategoryStatus(status, visibleCards.length === 0);

    if (scrollToGrid) {
      var grid = document.querySelector('.product-grid');
      scrollToCorporateTarget(grid);
    }
  }
  /* END TEMP BECCHI PLATEAUX DEMO NERF */

  function scrollToCorporateTarget(target) {
    if (!target) return;
    var header = document.querySelector('.site-header');
    var stickyNav = document.querySelector('.corporate-category-strip');
    var eventSteps = document.querySelector('.event-builder > .event-builder__steps');
    var headerOffset = header && window.getComputedStyle(header).position === 'fixed' ? header.offsetHeight : 0;
    var categoryOffset = headerOffset + (stickyNav ? stickyNav.offsetHeight : 0);
    /* Les étapes du composeur sont sticky elles aussi. Leur position réelle
       est plus fiable que leur seule hauteur : elle couvre les en-têtes
       mobiles et desktop, et évite de faire défiler le titre sous les étapes. */
    var stepsOffset = eventSteps && window.getComputedStyle(eventSteps).position === 'sticky'
      ? Math.max(0, eventSteps.getBoundingClientRect().bottom)
      : 0;
    var stickyOffset = Math.max(categoryOffset, stepsOffset) + 14;
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset;
    window.scrollTo({ behavior: 'smooth', top: Math.max(0, targetTop) });
  }

  /*
    Boissons proposées sous chaque catégorie (retour client) : les produits
    « boissons » synchronisés depuis FastEvent sont déplacés en fin de grille
    sous un intertitre, quel que soit le filtre de catégorie actif.
  */
  function appendBoissonsSection(cards, filter) {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var divider = document.querySelector('[data-boissons-divider]');
    var boissonCards = cards.filter(function (card) {
      return productMatchesCorporateFilter(card, 'boissons');
    });

    if (boissonCards.length === 0 || !filter || filter === 'boissons') {
      if (divider) divider.hidden = true;
      return;
    }

    if (!divider) {
      divider = document.createElement('h2');
      divider.className = 'product-grid__boissons-divider';
      divider.setAttribute('data-boissons-divider', '');
      divider.textContent = 'Boissons';
    }
    grid.appendChild(divider);
    divider.hidden = false;
    boissonCards.forEach(function (card) {
      card.hidden = false;
      grid.appendChild(card);
    });
  }

  function applyCorporateFilter(filter, activeLink, scrollToGrid) {
    var requestId = ++corporateFilterRequestId;
    document.documentElement.setAttribute('data-corporate-filter', filter);

    var hasFullProductGrid = Boolean(document.querySelector('.product-grid'));

    if (!hasFullProductGrid && scrollToGrid) {
      window.location.href = '/collections/all?clf=' + encodeURIComponent(filter);
      return;
    }

    document.querySelectorAll('[data-corporate-menu-filter]').forEach(function (item) {
      item.classList.toggle('is-active', item === activeLink || item.getAttribute('data-corporate-menu-filter') === filter);
    });

    var collectionHeading = document.querySelector('[data-collection-heading]');
    var activeStripLink = document.querySelector('[data-corporate-menu-filter="' + filter + '"]');
    if (collectionHeading && activeStripLink) {
      collectionHeading.textContent = activeStripLink.textContent.trim();
    }
    if (activeStripLink) {
      document.querySelectorAll('[data-corporate-mobile-category-current]').forEach(function (current) {
        current.textContent = activeStripLink.textContent.trim();
      });
    }
    document.querySelectorAll('[data-corporate-category-select]').forEach(function (select) {
      select.removeAttribute('open');
    });

    /*
      Filtre immédiat des cartes déjà rendues (avant l'hydratation des pages
      suivantes) : sans cela, la page affiche toutes les cartes puis les masque
      d'un coup à la fin de l'hydratation — l'effondrement de hauteur ramenait
      le scroll de l'utilisateur en haut de page.
    */
    var initialCards = getCorporateCards();
    if (initialCards.length > 0) {
      var initialMatching = initialCards.filter(function (card) {
        return productMatchesCorporateFilter(card, filter);
      });
      initialCards.forEach(function (card) {
        card.hidden = initialMatching.indexOf(card) === -1;
      });
      updateCorporateCollectionCount(initialMatching.length);
      var initialPagination = document.querySelector('.pagination');
      if (initialPagination) initialPagination.hidden = true;
    }

    hydrateCorporateCollectionGrid().then(function (cards) {
      if (requestId !== corporateFilterRequestId) return;

      var status = document.querySelector('[data-corporate-category-status]');
      var pagination = document.querySelector('.pagination');
      var matchingCards = cards.filter(function (card) {
        return productMatchesCorporateFilter(card, filter);
      });

      if (cards.length === 0) return;

      if (filter === 'plateaux-repas') {
        applyPlateauxDemoGroup('all', false);
      } else {
        removePlateauxDemoChooser();
      }

      if (matchingCards.length > 0) {
        cards.forEach(function (card) {
          card.hidden = matchingCards.indexOf(card) === -1;
        });
        setCorporateCategoryStatus(status, false);
      } else {
        cards.forEach(function (card) {
          card.hidden = true;
        });
        setCorporateCategoryStatus(status, true);
      }

      updateCorporateCollectionCount(matchingCards.length);
      if (pagination) pagination.hidden = true;
      appendBoissonsSection(cards, filter);

      if (scrollToGrid) {
        var grid = filter === 'plateaux-repas'
          ? document.querySelector('[data-plateaux-demo-chooser]')
          : document.querySelector('.product-grid, .product-carousel__track');
        scrollToCorporateTarget(grid);
      }
    });
  }

  document.addEventListener('click', function (event) {
    var plateauxDemoGroup = event.target.closest('[data-plateaux-demo-group]');
    if (plateauxDemoGroup) {
      event.preventDefault();
      applyPlateauxDemoGroup(plateauxDemoGroup.getAttribute('data-plateaux-demo-group'), plateauxDemoGroup.getAttribute('data-plateaux-demo-group') !== 'all');
      return;
    }

    var filterLink = event.target.closest('[data-corporate-menu-filter]');
    if (filterLink) {
      var collectionPage = filterLink.closest('.collection-page') || document.querySelector('.collection-page');
      var hasFullProductGrid = Boolean(document.querySelector('.product-grid'));
      if (!collectionPage || !hasFullProductGrid) return;
      event.preventDefault();
      var filter = filterLink.getAttribute('data-corporate-menu-filter');
      applyCorporateFilter(filter, filterLink, true);
    }

    var filterToggle = event.target.closest('[data-corporate-filter-toggle]');
    if (filterToggle) {
      event.preventDefault();
      var filters = document.querySelector('.collection-filters');
      var gridFallback = document.querySelector('.product-grid, .product-carousel__track');
      var collectionPage = filterToggle.closest('.collection-page') || document.querySelector('.collection-page');

      if (filters && isCorporateMobileLayout() && collectionPage) {
        var shouldOpenFilters = !collectionPage.classList.contains('is-filters-open');
        collectionPage.classList.toggle('is-filters-open', shouldOpenFilters);
        filterToggle.setAttribute('aria-expanded', shouldOpenFilters ? 'true' : 'false');
        if (shouldOpenFilters) scrollToCorporateTarget(filters);
        return;
      }

      scrollToCorporateTarget(filters || gridFallback || filterToggle);
    }
  });

  window.addEventListener('resize', function () {
    var chooser = document.querySelector('[data-plateaux-demo-chooser]');
    if (chooser && !chooser.hidden) mountPlateauxDemoChooser(chooser);
  });

  if (window.URLSearchParams) {
    var corporateFilterFromUrl = new URLSearchParams(window.location.search).get('clf');
    if (corporateFilterFromUrl) {
      applyCorporateFilter(corporateFilterFromUrl, null, false);
    } else if (document.querySelector('.product-grid')) {
      /*
        Sans filtre de catégorie, personne ne déclenchait l'hydratation : la
        page n'affichait que les 50 premiers produits et, la pagination étant
        masquée, les suivants devenaient inatteignables. On hydrate donc aussi
        le catalogue complet, puis on recale le compteur sur ce qui est
        réellement affiché (les prestations sont exclues du rendu).
      */
      hydrateCorporateCollectionGrid().then(function (cards) {
        updateCorporateCollectionCount(cards.length);
      });
    }
  }

  document.querySelectorAll('[data-event-builder]').forEach(function (builder) {
    var guestsInput = builder.querySelector('[data-event-guests]');
    var typeSelect = builder.querySelector('[data-event-type]');
    var packageSelect = builder.querySelector('[data-event-package]');
    var piecesInput = builder.querySelector('[data-event-pieces-per-person]');
    var dateInput = builder.querySelector('[data-event-date]');
    var startInput = builder.querySelector('[data-event-start]');
    var endInput = builder.querySelector('[data-event-end]');
    var mainCocktailBlock = builder.querySelector('[data-event-cocktail]:not([data-event-cocktail-extra])');
    var extraCocktailsContainer = builder.querySelector('[data-event-extra-cocktails]');
    var cocktailTemplate = builder.querySelector('[data-event-cocktail-template]');
    var addCocktailButton = builder.querySelector('[data-event-add-cocktail]');
    var cocktailTabs = builder.querySelector('[data-event-cocktail-tabs]');
    var staffMealToggle = builder.querySelector('[data-event-staff-meal-toggle]');
    var staffMealItems = builder.querySelector('[data-event-staff-meal-items]');
    var contactInput = builder.querySelector('[data-event-contact]');
    var emailInput = builder.querySelector('[data-event-email]');
    var phoneInput = builder.querySelector('[data-event-phone]');
    var quantityInputs = Array.prototype.slice.call(builder.querySelectorAll('[data-event-quantity-input]'));
    var presetButtons = Array.prototype.slice.call(builder.querySelectorAll('[data-event-preset-pieces]'));
    var customPiecesButton = builder.querySelector('[data-event-custom-pieces]');
    var selection = builder.querySelector('[data-event-selection]');
    var recap = builder.querySelector('[data-event-recap]');
    var recapDetails = builder.querySelector('[data-event-recap-details]');
    var empty = builder.querySelector('[data-event-empty]');
    var total = builder.querySelector('[data-event-total]');
    var recapProgress = builder.querySelector('[data-event-recap-progress]');
    var recapMeta = builder.querySelector('[data-event-recap-meta]');
    var selectionCount = builder.querySelector('[data-event-selection-count]');
    var estimateLabel = builder.querySelector('[data-event-estimate-label]');
    var estimateNote = builder.querySelector('[data-event-estimate-note]');
    var packageTotal = builder.querySelector('[data-event-package-total]');
    var addonsTotal = builder.querySelector('[data-event-addons-total]');
    var quoteTotal = builder.querySelector('[data-event-quote-total]');
    var totalHt = builder.querySelector('[data-event-total-ht]');
    var totalTva = builder.querySelector('[data-event-total-tva]');
    var piecesUsed = builder.querySelector('[data-event-pieces-used]');
    var piecesBreakdown = builder.querySelector('[data-event-pieces-breakdown]');
    var piecesStatus = builder.querySelector('[data-event-pieces-status]');
    var mobilePiecesStatus = builder.querySelector('[data-event-mobile-pieces-status]');
    var mobilePiecesUsed = builder.querySelector('[data-event-mobile-pieces-used]');
    var mobilePiecesBreakdown = builder.querySelector('[data-event-mobile-pieces-breakdown]');
    var formulaHint = builder.querySelector('[data-event-formula-hint]');
    var quoteNote = builder.querySelector('[data-event-quote-note]');
    var message = builder.querySelector('[data-event-message]');
    var addButton = builder.querySelector('[data-event-add]');
    var previousButton = builder.querySelector('[data-event-previous]');
    var requestUrl = builder.getAttribute('data-event-request-url') || '';
    var stepButtons = Array.prototype.slice.call(builder.querySelectorAll('[data-event-step-button]'));
    var groups = Array.prototype.slice.call(builder.querySelectorAll('[data-event-group][data-event-step-index]'));
    var salleGate = builder.querySelector('[data-event-salle-gate]');
    var salleChoiceBlock = builder.querySelector('[data-event-salle-choice]');
    var salleChoiceLabel = builder.querySelector('[data-event-salle-choice-label]');
    var salleChangeButton = builder.querySelector('[data-event-salle-change]');
    var salleItemsEl = builder.querySelector('[data-event-salle-items]');
    var salleAnswerButtons = Array.prototype.slice.call(builder.querySelectorAll('[data-event-salle-answer]'));
    var salleChoice = null;
    var reviewPanel = builder.querySelector('[data-event-review-panel]');
    var recapCard = builder.querySelector('[data-event-recap-card]');
    var stepHeading = builder.querySelector('[data-event-step-heading]');
    var stepKicker = builder.querySelector('[data-event-step-kicker]');
    var stepTitle = builder.querySelector('[data-event-step-title]');
    var stepDetail = builder.querySelector('[data-event-step-detail]');
    var finalStep = 3;
    var currentStep = 0;
    var inlineValidationUpToStep = null;
    var stepMeta = [
      {
        title: 'Votre cocktail',
        detail: 'Définissez les pièces par personne, puis composez votre cocktail bouchée par bouchée.'
      },
      {
        title: 'Votre lieu',
        detail: 'Avez-vous besoin d’une salle ? Cette étape est entièrement facultative.'
      },
      {
        title: 'Vos options',
        detail: 'Ajoutez uniquement les services, repas ou animations qui vous simplifient la vie.'
      },
      {
        title: 'Votre demande',
        detail: 'Vérifiez votre sélection et vos coordonnées avant de l’envoyer à Becchi.'
      }
    ];

    function money(cents) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format((Number(cents) || 0) / 100);
    }

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    function asNumber(value, fallback) {
      var parsed = Number(String(value || '').replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    function centsFromEuros(value, fallbackCents) {
      if (value === null || value === undefined || value === '') return fallbackCents || 0;
      var parsed = asNumber(value, NaN);
      return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed * 100)) : (fallbackCents || 0);
    }

    function taxBreakdown(unitHtCents, unitTtcCents, tvaRate) {
      var ht = Math.max(0, Math.round(Number(unitHtCents) || 0));
      var ttc = Math.max(0, Math.round(Number(unitTtcCents) || 0));
      var rate = Math.max(0, asNumber(tvaRate, 0));

      /*
        Même règle que le serveur (computeMoneyBreakdown) : HT et TTC fournis
        font foi, seul le montant manquant est dérivé du taux. Sinon le récap
        affichait un TTC recalculé différent du prix catalogue et du total
        serveur.
      */
      if (ht > 0 && ttc <= 0 && rate > 0) ttc = Math.round(ht * (1 + rate / 100));
      if (ttc > 0 && ht <= 0 && rate > 0) ht = Math.round(ttc / (1 + rate / 100));
      if (ttc > 0 && ht <= 0) ht = ttc;
      if (ht > 0 && ttc <= 0) ttc = ht;

      return {
        ht: ht,
        tva: Math.max(0, ttc - ht),
        ttc: ttc,
        rate: rate
      };
    }

    function formatQuantity(value) {
      var number = Number(value) || 0;
      if (Number.isInteger(number)) return String(number);
      return number.toLocaleString('fr-FR', { maximumFractionDigits: 2 });
    }

    function pieceLabel(value) {
      var formatted = formatQuantity(value);
      return formatted + ' pièce' + (Number(value) > 1 ? 's' : '');
    }

    var MINIMUM_LEAD_TIME_HOURS = 48;

    function hasMinimumLeadTime(dateValue, timeValue, leadTimeHours) {
      if (!dateValue) return false;
      var eventStart = new Date(dateValue + 'T' + (timeValue || '00:00') + ':00');
      if (Number.isNaN(eventStart.getTime())) return false;
      var minimumStart = Date.now() + leadTimeHours * 60 * 60 * 1000;
      return eventStart.getTime() >= minimumStart;
    }

    if (dateInput) {
      var minLeadDate = new Date(Date.now() + MINIMUM_LEAD_TIME_HOURS * 60 * 60 * 1000);
      dateInput.min = minLeadDate.toISOString().slice(0, 10);
    }

    function cocktailPieceEquivalent(value, isCocktail) {
      var fallback = isCocktail ? 1 : 0;
      var parsed = asNumber(value, fallback);
      if (!isCocktail) return Math.max(0, parsed);
      return parsed > 0 ? parsed : 1;
    }

    function selectedPackage() {
      var manualPieces = Math.max(0, asNumber(piecesInput && piecesInput.value, 0));
      if (!packageSelect || !packageSelect.value) {
        return {
          variantId: '',
          title: '',
          price: 0,
          unitHtCents: 0,
          unitTtcCents: 0,
          tvaRate: 0,
          boutiqueId: '',
          piecesPerPerson: manualPieces,
          quoteOnly: false
        };
      }
      var option = packageSelect.options[packageSelect.selectedIndex];
      var variantPrice = option ? asNumber(option.getAttribute('data-price'), 0) : 0;
      var unitTtcCents = option ? centsFromEuros(option.getAttribute('data-price-ttc'), variantPrice) : 0;
      var unitHtCents = option ? centsFromEuros(option.getAttribute('data-price-ht'), 0) : 0;
      var tvaRate = option ? asNumber(option.getAttribute('data-tva'), 0) : 0;
      var money = taxBreakdown(unitHtCents, unitTtcCents, tvaRate);
      return {
        variantId: packageSelect.value,
        title: option ? (option.getAttribute('data-title') || option.textContent || '') : '',
        price: money.ttc,
        unitHtCents: money.ht,
        unitTtcCents: money.ttc,
        tvaRate: tvaRate,
        boutiqueId: option ? (option.getAttribute('data-boutique-id') || '') : '',
        piecesPerPerson: option ? asNumber(option.getAttribute('data-pieces'), manualPieces) : manualPieces,
        quoteOnly: packageSelect.value && money.ttc === 0
      };
    }

    function itemDataFromElement(item, quantity) {
        var group = item.getAttribute('data-event-group') || '';
        var elementType = item.getAttribute('data-element-type') || '';
        var isCocktail = item.getAttribute('data-is-cocktail') === 'true' || group === 'cocktails';
        var pieceEquivalent = cocktailPieceEquivalent(item.getAttribute('data-piece-equivalent'), isCocktail);
        var unitTtcCents = centsFromEuros(item.getAttribute('data-product-price-ttc'), Number(item.getAttribute('data-product-price') || 0));
        var unitHtCents = centsFromEuros(item.getAttribute('data-product-price-ht'), 0);
        var tvaRate = asNumber(item.getAttribute('data-product-tva'), 0);
        var money = taxBreakdown(unitHtCents, unitTtcCents, tvaRate);
        return {
          variantId: item.getAttribute('data-variant-id'),
          title: item.getAttribute('data-product-title') || '',
          price: money.ttc,
          unitHtCents: money.ht,
          unitTtcCents: money.ttc,
          tvaRate: tvaRate,
          quoteOnly: item.getAttribute('data-quote-only') === 'true' || (!isCocktail && money.ttc === 0),
          group: group,
          elementType: elementType,
          boutiqueId: item.getAttribute('data-boutique-id') || '',
          elementId: item.getAttribute('data-element-id') || '',
          isCocktail: isCocktail,
          pieceEquivalent: pieceEquivalent,
          pieceUnits: isCocktail ? quantity * pieceEquivalent : 0,
          quantity: quantity
        };
    }

    function selectedItems() {
      return quantityInputs.map(function (input) {
        var item = input.closest('[data-event-item]');
        var quantity = Math.max(0, Number(input.value || 0));
        if (!item || quantity < 1) return null;
        return itemDataFromElement(item, quantity);
      }).filter(Boolean);
    }

    function lineMoney(item) {
      var breakdown = taxBreakdown(item.unitHtCents, item.unitTtcCents, item.tvaRate);
      var count = Math.max(1, Number(item.quantity) || 1);
      return {
        ht: item.quoteOnly || item.isCocktail ? 0 : breakdown.ht * count,
        tva: item.quoteOnly || item.isCocktail ? 0 : breakdown.tva * count,
        ttc: item.quoteOnly || item.isCocktail ? 0 : breakdown.ttc * count
      };
    }

    function packageMoney(pack, guests) {
      var breakdown = taxBreakdown(pack.unitHtCents, pack.unitTtcCents, pack.tvaRate);
      if (!pack.variantId || pack.quoteOnly) return { ht: 0, tva: 0, ttc: 0 };
      return {
        ht: breakdown.ht * guests,
        tva: breakdown.tva * guests,
        ttc: breakdown.ttc * guests
      };
    }

    function stepForGroup(groupKey) {
      if (groupKey === 'cocktails') return 0;
      if (groupKey === 'salles') return 1;
      return 2;
    }

    function stepTarget(step) {
      if (step === finalStep) return recapCard || reviewPanel || stepHeading || builder.querySelector('[data-event-pieces-status]');
      return builder.querySelector('[data-event-step-index="' + step + '"]');
    }

    function resetSelectionAfterSend() {
      quantityInputs.forEach(function (input) {
        input.value = 0;
      });
      Object.keys(cocktailSelections).forEach(function (key) {
        cocktailSelections[key] = {};
      });
      updateSummary();
      setBuilderStep(0, true);
    }

    function setBuilderStep(step, shouldScroll) {
      currentStep = Math.max(0, Math.min(finalStep, Number(step) || 0));
      builder.setAttribute('data-event-step', String(currentStep));
      builder.classList.toggle('is-first-step', currentStep === 0);
      builder.classList.toggle('is-final-step', currentStep === finalStep);
      builder.classList.toggle('is-cocktail-step', currentStep === 0);

      groups.forEach(function (group) {
        var groupStep = Number(group.getAttribute('data-event-step-index') || 2);
        var groupKey = group.getAttribute('data-event-group');
        var isSalleGroup = groupKey === 'salles';
        var hasItems = Boolean(group.querySelector('[data-event-item]'));
        group.hidden = currentStep === finalStep || groupStep !== currentStep || (!isSalleGroup && !hasItems);
      });

      renderSalleGate();

      if (reviewPanel) reviewPanel.hidden = currentStep !== finalStep;

      stepButtons.forEach(function (button) {
        var buttonStep = Number(button.getAttribute('data-event-step-button') || 0);
        button.classList.toggle('is-active', buttonStep === currentStep);
        button.classList.toggle('is-complete', buttonStep < currentStep);
        button.setAttribute('aria-current', buttonStep === currentStep ? 'step' : 'false');
      });

      var meta = stepMeta[currentStep] || stepMeta[0];
      if (stepKicker) stepKicker.textContent = 'Étape ' + (currentStep + 1) + ' / ' + (finalStep + 1);
      if (stepTitle) stepTitle.textContent = meta.title;
      if (stepDetail) stepDetail.textContent = meta.detail;
      if (previousButton) {
        previousButton.hidden = currentStep === 0;
        previousButton.disabled = currentStep === 0 || Boolean(addButton && addButton.disabled);
      }
      if (addButton) {
        var actionLabels = [
          'Continuer vers votre lieu',
          'Continuer vers vos options',
          'Voir ma demande',
          'Envoyer ma demande'
        ];
        addButton.textContent = actionLabels[currentStep] || 'Continuer';
      }
      if (message) {
        message.textContent = '';
        message.dataset.tone = '';
      }

      if (shouldScroll) scrollToCorporateTarget(stepTarget(currentStep) || builder);

      lockCocktailEditing(currentStep > 0);
      renderCocktailTabs();
      if (currentStep === 2) updateStaffingSuggestions();
    }

    /*
      Retour client : l'étape Cocktails est la SEULE où l'on peut choisir le
      format, le nombre de pièces, les horaires ou ajouter un cocktail. Dès
      qu'on avance (Salles, Options, Récapitulatif), tout cela est verrouillé —
      sinon on envoie une demande qui ne correspond plus à ce qui a été
      composé. Pour modifier, il faut revenir à l'étape Cocktails.
    */
    function lockCocktailEditing(locked) {
      var controls = Array.prototype.slice.call(builder.querySelectorAll(
        '[data-event-type], [data-event-pieces-per-person], [data-event-start], [data-event-end],' +
        '[data-event-preset-pieces], [data-event-custom-pieces], [data-event-add-cocktail],' +
        '[data-cocktail-format], [data-cocktail-pieces], [data-cocktail-start], [data-cocktail-end],' +
        '[data-cocktail-preset], [data-cocktail-remove]'
      ));
      controls.forEach(function (control) {
        control.disabled = locked;
      });
      var lockNote = builder.querySelector('[data-event-cocktail-lock-note]');
      if (lockNote) lockNote.hidden = !locked;
      builder.classList.toggle('is-cocktail-locked', locked);
    }

    function renderSalleGate() {
      if (!salleGate) return;
      var onSalleStep = currentStep === 1;

      salleGate.hidden = !onSalleStep || Boolean(salleChoice);

      if (salleChoiceBlock) salleChoiceBlock.hidden = !onSalleStep || !salleChoice;
      if (salleChoiceLabel && salleChoice) {
        salleChoiceLabel.textContent = salleChoice === 'yes'
          ? 'Vous souhaitez une proposition de salle.'
          : 'Vous avez déjà un lieu.';
      }
      if (salleItemsEl) salleItemsEl.hidden = !onSalleStep || salleChoice !== 'yes';
    }

    function setSalleChoice(choice) {
      salleChoice = choice;
      renderSalleGate();
      refreshInlineBuilderValidation();
      if (message) {
        message.textContent = '';
        message.dataset.tone = '';
      }
      if (choice === 'no') {
        setBuilderStep(2, true);
      }
    }

    var staffingNote = builder.querySelector('[data-event-staffing-note]');
    var staffingRequestKey = '';

    function updateStaffingSuggestions() {
      if (!staffingNote) return;
      var webhookUrl = builder.getAttribute('data-event-request-url') || '';
      var shopDomain = builder.getAttribute('data-event-shop') || (window.Shopify && window.Shopify.shop) || '';
      if (!webhookUrl || !shopDomain) return;
      var apiOrigin;
      try {
        apiOrigin = new URL(webhookUrl, window.location.href).origin;
      } catch (error) {
        return;
      }
      var guests = Math.max(1, asNumber(guestsInput && guestsInput.value, 1));
      var format = typeSelect ? typeSelect.value : '';
      var key = apiOrigin + '|' + shopDomain + '|' + guests + '|' + format;
      if (key === staffingRequestKey) return;
      staffingRequestKey = key;

      var endpoint = apiOrigin + '/api/shopify/besoins-personnel?shop=' + encodeURIComponent(shopDomain) + '&guests=' + encodeURIComponent(guests) + (format ? '&type=' + encodeURIComponent(format) : '');
      fetch(endpoint, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('besoins personnel');
          return response.json();
        })
        .then(function (data) {
          if (staffingRequestKey !== key) return;
          var suggestions = (data && data.suggestions) || [];
          if (suggestions.length === 0) {
            staffingNote.hidden = true;
            staffingNote.textContent = '';
            return;
          }
          var parts = suggestions.map(function (item) {
            return item.count + ' ' + item.label;
          });
          var suffix = staffingNote.getAttribute('data-event-staffing-suffix') || '';
          staffingNote.textContent = 'Pour ' + guests + ' convives, nous vous conseillons : ' + parts.join(', ') + (suffix ? ' (' + suffix + ')' : '') + '.';
          staffingNote.hidden = false;
        })
        .catch(function () {
          if (staffingRequestKey === key) staffingRequestKey = '';
        });
    }

    var summaryGroupLabels = {
      cocktails: 'Formule cocktail',
      salles: 'Salles',
      services: 'Services',
      animations: 'Animations',
      repas: "Repas d'équipe",
      plateaux: 'Plateaux repas',
      buffets: 'Formats à partager',
      compositions: 'Compositions Becchi',
      boissons: 'Boissons'
    };

    var summaryGroupOrder = ['cocktails', 'salles', 'services', 'animations', 'repas', 'plateaux', 'buffets', 'compositions', 'boissons'];

    function renderRecapItemRow(item) {
      var details = [];
      if (item.isCocktail) details.push(pieceLabel(item.pieceUnits));
      if (item.quoteOnly) details.push('Sur devis');
      var detail = details.length > 0
        ? '<small>' + escapeHtml(details.join(' · ')) + '</small>'
        : '';
      return '<tr>' +
        '<td><strong>' + escapeHtml(item.title) + '</strong>' + detail + '</td>' +
        '<td class="event-builder__recap-quantity">× ' + escapeHtml(formatQuantity(item.quantity)) + '</td>' +
      '</tr>';
    }

    function renderSelectionRows(items) {
      var groupsByKey = items.reduce(function (acc, item) {
        if (!acc[item.group]) acc[item.group] = [];
        acc[item.group].push(item);
        return acc;
      }, {});

      return summaryGroupOrder.concat(Object.keys(groupsByKey).filter(function (key) {
        return summaryGroupOrder.indexOf(key) === -1;
      })).filter(function (key, index, allKeys) {
        return allKeys.indexOf(key) === index && groupsByKey[key];
      }).map(function (key) {
        var groupRows = groupsByKey[key].map(renderRecapItemRow).join('');
        return '<tr class="event-builder__recap-section"><td colspan="2">' + escapeHtml(summaryGroupLabels[key] || key) + '</td></tr>' + groupRows;
      }).join('');
    }

    function cocktailFormatLabel(cocktail) {
      var select = cocktail.isMain ? typeSelect : (function () {
        var block = extraBlockForKey(cocktail.key);
        return block ? block.querySelector('[data-cocktail-format]') : null;
      })();
      if (select && select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
        var text = (select.options[select.selectedIndex].textContent || '').trim();
        if (text) return text;
      }
      return cocktail.format || '';
    }

    function renderCocktailRecapRows(cocktail) {
      var formatLabel = cocktailFormatLabel(cocktail);
      var hoursLabel = cocktail.start && cocktail.end
        ? cocktail.start + ' – ' + cocktail.end
        : cocktail.start;
      var heading = cocktailLabelForKey(cocktail.key)
        + (formatLabel ? ' · ' + formatLabel : '');
      var piecesMeta = cocktail.pieces > 0
        ? formatQuantity(cocktail.used) + ' / ' + formatQuantity(cocktail.pieces) + ' pièces'
        : formatQuantity(cocktail.used) + ' pièce' + (cocktail.used > 1 ? 's' : '');
      var meta = [piecesMeta];
      if (hoursLabel) meta.push(hoursLabel);
      var rows = '<tr class="event-builder__recap-section event-builder__recap-section--cocktail"><td colspan="2">' +
        '<strong>' + escapeHtml(heading) + '</strong><small>' + escapeHtml(meta.join(' · ')) + '</small></td></tr>';
      if (cocktail.items.length === 0) {
        return rows + '<tr class="event-builder__recap-note event-builder__recap-note--empty"><td colspan="2">Aucune pièce sélectionnée pour ce cocktail.</td></tr>';
      }
      return rows + cocktail.items.map(renderRecapItemRow).join('');
    }

    function recapEventDate(value) {
      if (!value) return 'Date à confirmer';
      var date = new Date(value + 'T12:00:00');
      if (Number.isNaN(date.getTime())) return 'Date à confirmer';
      return new Intl.DateTimeFormat('fr-FR', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }).format(date);
    }

    function computeSummary() {
      var items = selectedItems();
      var guests = Math.max(1, asNumber(guestsInput && guestsInput.value, 1));
      var pack = selectedPackage();
      var piecesPerPerson = Math.max(0, pack.piecesPerPerson || asNumber(piecesInput && piecesInput.value, 0));
      var totalPieceBudget = activeCocktailBudget();
      var usedPieceBudget = items.reduce(function (sum, item) {
        return sum + item.pieceUnits;
      }, 0);
      var packMoney = packageMoney(pack, guests);
      var addonsMoney = items.reduce(function (acc, item) {
        var itemMoney = lineMoney(item);
        acc.ht += itemMoney.ht;
        acc.tva += itemMoney.tva;
        acc.ttc += itemMoney.ttc;
        return acc;
      }, { ht: 0, tva: 0, ttc: 0 });
      var totalMoney = {
        ht: packMoney.ht + addonsMoney.ht,
        tva: packMoney.tva + addonsMoney.tva,
        ttc: packMoney.ttc + addonsMoney.ttc
      };
      var hasQuoteOnly = items.some(function (item) {
        return item.quoteOnly;
      }) || Boolean(pack.variantId && pack.quoteOnly);
      return {
        items: items,
        guests: guests,
        pack: pack,
        piecesPerPerson: piecesPerPerson,
        totalPieceBudget: totalPieceBudget,
        usedPieceBudget: usedPieceBudget,
        packageMoney: packMoney,
        addonsMoney: addonsMoney,
        totalMoney: totalMoney,
        hasQuoteOnly: hasQuoteOnly,
        quoteCount: items.filter(function (item) { return item.quoteOnly; }).length + (pack.variantId && pack.quoteOnly ? 1 : 0)
      };
    }

    function quantityContext(input) {
      var item = input && input.closest('[data-event-item]');
      var group = item ? (item.getAttribute('data-event-group') || '') : '';
      var isCocktail = Boolean(item) && (item.getAttribute('data-is-cocktail') === 'true' || group === 'cocktails');
      return {
        item: item,
        control: input && input.closest('[data-event-quantity]'),
        isCocktail: isCocktail,
        pieceEquivalent: cocktailPieceEquivalent(item && item.getAttribute('data-piece-equivalent'), isCocktail)
      };
    }

    function clampQuantityForInput(input, value) {
      var requested = Math.max(0, Math.floor(Number(value || 0)));
      var context = quantityContext(input);
      if (!context.isCocktail || context.pieceEquivalent <= 0) return requested;
      var summary = computeSummary();
      if (summary.totalPieceBudget <= 0) return requested;
      var currentQuantity = Math.max(0, Number(input.value || 0));
      var currentUnits = currentQuantity * context.pieceEquivalent;
      var availableUnits = Math.max(0, summary.totalPieceBudget - (summary.usedPieceBudget - currentUnits));
      return Math.min(requested, Math.floor(availableUnits / context.pieceEquivalent));
    }

    function clampCocktailQuantitiesToBudget() {
      var totalPieceBudget = activeCocktailBudget();
      if (totalPieceBudget <= 0) return;
      var usedPieceBudget = 0;
      quantityInputs.forEach(function (input) {
        var context = quantityContext(input);
        if (!context.isCocktail || context.pieceEquivalent <= 0) return;
        var quantity = Math.max(0, Math.floor(Number(input.value || 0)));
        var maxQuantity = Math.floor(Math.max(0, totalPieceBudget - usedPieceBudget) / context.pieceEquivalent);
        if (quantity > maxQuantity) {
          quantity = maxQuantity;
          input.value = quantity;
        }
        usedPieceBudget += quantity * context.pieceEquivalent;
      });
    }

    function updateQuantityControls(summary) {
      quantityInputs.forEach(function (input) {
        var context = quantityContext(input);
        var quantity = Math.max(0, Number(input.value || 0));
        var minus = context.control && context.control.querySelector('[data-event-minus]');
        var plus = context.control && context.control.querySelector('[data-event-plus]');
        if (minus) minus.disabled = quantity <= 0;
        if (!context.isCocktail || context.pieceEquivalent <= 0 || summary.totalPieceBudget <= 0) {
          if (plus) plus.disabled = false;
          input.removeAttribute('max');
          return;
        }
        var usedExcludingCurrent = summary.usedPieceBudget - (quantity * context.pieceEquivalent);
        var maxQuantity = Math.floor(Math.max(0, summary.totalPieceBudget - usedExcludingCurrent) / context.pieceEquivalent);
        input.setAttribute('max', String(maxQuantity));
        if (plus) plus.disabled = quantity >= maxQuantity;
      });
    }

    function updateSummary() {
      var summary = computeSummary();
      var cocktails = collectAllCocktailData();
      var recapCocktails = cocktails.filter(function (cocktail) {
        return cocktail.items.length > 0 || (cocktails.length > 1 && cocktail.pieces > 0);
      });
      var nonCocktailItems = summary.items.filter(function (item) { return !item.isCocktail; });
      var hasRecapContent = recapCocktails.length > 0 || nonCocktailItems.length > 0;
      var recapItemCount = recapCocktails.reduce(function (count, cocktail) {
        return count + cocktail.items.length;
      }, 0) + nonCocktailItems.length;
      if (selection) {
        selection.innerHTML = recapCocktails.map(renderCocktailRecapRows).join('') + renderSelectionRows(nonCocktailItems);
      }
      if (empty) empty.hidden = hasRecapContent;
      if (recap) recap.hidden = !hasRecapContent;
      if (recapDetails) recapDetails.hidden = !hasRecapContent;
      if (selectionCount) {
        selectionCount.textContent = recapItemCount + ' article' + (recapItemCount > 1 ? 's' : '');
      }
      if (recapMeta) {
        var guestsLabel = formatQuantity(summary.guests) + ' convive' + (summary.guests > 1 ? 's' : '');
        recapMeta.textContent = guestsLabel + ' · ' + recapEventDate(dateInput && dateInput.value);
      }
      var multiCocktail = cocktailKeysList().length > 1;
      var piecesUsageLabel = (multiCocktail ? cocktailLabelForKey(activeCocktailKey) + ' : ' : '') + pieceLabel(summary.usedPieceBudget) + ' / ' + pieceLabel(summary.totalPieceBudget);
      var piecesFormulaLabel = multiCocktail
        ? cocktailLabelForKey(activeCocktailKey) + ' \u2014 ' + pieceLabel(summary.totalPieceBudget) + ' par personne'
        : 'Formule cocktail ' + pieceLabel(summary.piecesPerPerson) + ' pour ' + formatQuantity(summary.guests) + ' personne' + (summary.guests > 1 ? 's' : '');
      if (piecesUsed) piecesUsed.textContent = piecesUsageLabel;
      if (piecesBreakdown) piecesBreakdown.textContent = piecesFormulaLabel;
      if (mobilePiecesUsed) mobilePiecesUsed.textContent = piecesUsageLabel;
      if (mobilePiecesBreakdown) mobilePiecesBreakdown.textContent = piecesFormulaLabel;
      function cocktailFormulaCopy(pieces) {
        if (pieces <= 0) return 'Choisissez un format ou saisissez directement votre nombre de pièces par personne.';
        var guestsLabel = formatQuantity(summary.guests) + ' convive' + (summary.guests > 1 ? 's' : '');
        return pieceLabel(pieces) + ' par personne pour ' + guestsLabel + ' : ' + pieceLabel(pieces * summary.guests) + ' à prévoir.';
      }
      if (formulaHint) {
        /* Cette aide appartient au panneau Cocktail n°1 : elle ne doit pas
           reprendre le budget d'un éventuel Cocktail n°2 actif. */
        var primaryCocktailBudget = budgetForCocktailKey('c1');
        formulaHint.textContent = cocktailFormulaCopy(primaryCocktailBudget);
      }
      getExtraCocktailBlocks().forEach(function (block) {
        var extraHint = block.querySelector('[data-cocktail-formula-hint]');
        var key = block.getAttribute('data-cocktail-key');
        if (extraHint && key) extraHint.textContent = cocktailFormulaCopy(budgetForCocktailKey(key));
      });
      if (piecesStatus) {
        piecesStatus.dataset.status = summary.usedPieceBudget > summary.totalPieceBudget ? 'over' : summary.usedPieceBudget === summary.totalPieceBudget ? 'complete' : 'open';
      }
      if (mobilePiecesStatus) {
        mobilePiecesStatus.dataset.status = summary.usedPieceBudget > summary.totalPieceBudget ? 'over' : summary.usedPieceBudget === summary.totalPieceBudget ? 'complete' : 'open';
      }
      var matchesPreset = false;
      presetButtons.forEach(function (button) {
        var isActive = asNumber(button.getAttribute('data-event-preset-pieces'), -1) === summary.piecesPerPerson;
        if (isActive) matchesPreset = true;
        button.classList.toggle('is-active', isActive);
      });
      if (customPiecesButton) customPiecesButton.classList.toggle('is-active', summary.piecesPerPerson > 0 && !matchesPreset);
      updateQuantityControls(summary);
      var isCocktailReady = cocktails.length > 0 && cocktails.every(function (cocktail) {
        return cocktail.pieces > 0 && cocktail.used === cocktail.pieces && cocktail.start && cocktail.end;
      });
      if (recapProgress) {
        recapProgress.textContent = !hasRecapContent
          ? 'Votre sélection apparaîtra ici au fur et à mesure.'
          : (isCocktailReady
            ? 'Votre cocktail est prêt. Ajoutez la date et vos coordonnées pour l’envoyer.'
            : 'Finalisez votre cocktail pour poursuivre votre demande.');
      }
      var hasFixedEstimate = summary.totalMoney.ttc > 0 && !summary.hasQuoteOnly;
      if (estimateLabel) estimateLabel.textContent = hasFixedEstimate ? 'Total TTC estimé' : 'Prix de votre demande';
      if (estimateNote) {
        estimateNote.textContent = hasFixedEstimate
          ? 'Estimation calculée selon votre sélection actuelle.'
          : 'Le prix final sera confirmé par Becchi.';
      }
      if (packageTotal) packageTotal.textContent = summary.pack.variantId && summary.pack.quoteOnly ? 'Sur devis' : money(summary.packageMoney.ttc);
      if (addonsTotal) addonsTotal.textContent = money(summary.addonsMoney.ttc);
      if (quoteTotal) quoteTotal.textContent = summary.quoteCount > 0 ? summary.quoteCount + ' élément' + (summary.quoteCount > 1 ? 's' : '') + ' à confirmer' : 'Aucun';
      if (totalHt) totalHt.textContent = money(summary.totalMoney.ht);
      if (totalTva) totalTva.textContent = money(summary.totalMoney.tva);
      if (total) total.textContent = hasFixedEstimate ? money(summary.totalMoney.ttc) : 'Sur devis';
      if (quoteNote) quoteNote.hidden = !summary.hasQuoteOnly;
      if (message && hasRecapContent) {
        message.textContent = '';
        message.dataset.tone = '';
      }
      renderCocktailTabs();
      refreshInlineBuilderValidation();
    }

    function setQuantity(input, value) {
      input.value = clampQuantityForInput(input, value);
      updateSummary();
    }

    builder.addEventListener('click', function (event) {
      var stepButton = event.target.closest('[data-event-step-button]');
      if (stepButton) {
        event.preventDefault();
        setBuilderStep(stepButton.getAttribute('data-event-step-button'), true);
        return;
      }

      var previous = event.target.closest('[data-event-previous]');
      if (previous) {
        event.preventDefault();
        setBuilderStep(currentStep - 1, true);
        return;
      }

      var minus = event.target.closest('[data-event-minus]');
      var plus = event.target.closest('[data-event-plus]');
      if (minus || plus) {
        var control = event.target.closest('[data-event-quantity]');
        var input = control && control.querySelector('[data-event-quantity-input]');
        if (!input) return;
        setQuantity(input, Number(input.value || 0) + (plus ? 1 : -1));
        return;
      }

      var preset = event.target.closest('[data-event-preset-pieces]');
      if (preset && piecesInput) {
        piecesInput.value = Math.max(0, asNumber(preset.getAttribute('data-event-preset-pieces'), 0));
        syncFormatToPieces(typeSelect, asNumber(piecesInput.value, 0));
        clampCocktailQuantitiesToBudget();
        updateSummary();
        return;
      }

      var cocktailTab = event.target.closest('[data-cocktail-tab]');
      if (cocktailTab) {
        switchActiveCocktail(cocktailTab.getAttribute('data-cocktail-tab'));
        return;
      }

      var cocktailPreset = event.target.closest('[data-cocktail-preset]');
      if (cocktailPreset) {
        var presetBlock = cocktailPreset.closest('[data-event-cocktail-extra]');
        var presetPiecesField = presetBlock && presetBlock.querySelector('[data-cocktail-pieces]');
        if (presetPiecesField) {
          presetPiecesField.value = Math.max(0, asNumber(cocktailPreset.getAttribute('data-cocktail-preset'), 0));
          syncFormatToPieces(presetBlock.querySelector('[data-cocktail-format]'), asNumber(presetPiecesField.value, 0));
          refreshCocktailPresetActives(presetBlock);
          clampCocktailQuantitiesToBudget();
          updateSummary();
        }
        return;
      }

      var customPieces = event.target.closest('[data-event-custom-pieces]');
      if (customPieces && piecesInput) {
        event.preventDefault();
        piecesInput.focus();
        piecesInput.select();
      }
    });

    builder.addEventListener('event-builder:go-to-step', function (event) {
      var groupKey = event.detail && event.detail.groupKey;
      setBuilderStep(stepForGroup(groupKey), false);
    });

    quantityInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setQuantity(input, input.value);
      });
      input.addEventListener('input', function () {
        setQuantity(input, input.value);
      });
    });

    if (guestsInput) {
      guestsInput.addEventListener('change', function () {
        updateSummary();
        if (currentStep === 2) updateStaffingSuggestions();
      });
    }
    function getExtraCocktailBlocks() {
      return Array.prototype.slice.call(builder.querySelectorAll('[data-event-cocktail-extra]'));
    }

    function readExtraCocktail(block) {
      var formatSelect = block.querySelector('[data-cocktail-format]');
      var piecesField = block.querySelector('[data-cocktail-pieces]');
      var startField = block.querySelector('[data-cocktail-start]');
      var endField = block.querySelector('[data-cocktail-end]');
      return {
        format: formatSelect ? formatSelect.value : '',
        pieces: Math.max(0, asNumber(piecesField && piecesField.value, 0)),
        start: (startField && startField.value) || '',
        end: (endField && endField.value) || ''
      };
    }

    function updateCocktailHours(block, start, end) {
      var hours = block && block.querySelector('[data-cocktail-hours]');
      if (!hours) return;
      hours.textContent = start && end ? '(' + start + ' \u2013 ' + end + ')' : start ? '(' + start + ')' : '';
    }

    function renumberExtraCocktails() {
      getExtraCocktailBlocks().forEach(function (block, index) {
        var label = block.querySelector('[data-cocktail-label]');
        if (label) label.textContent = 'Cocktail n\u00b0' + (index + 2);
      });
    }

    /*
      Sélection des pièces PAR cocktail (retour Farhan v2) : chaque cocktail a
      ses propres quantités. Les onglets au-dessus du catalogue scopent la
      grille sur le cocktail actif ; les autres sélections sont mémorisées.
    */
    var cocktailSelections = {};
    var activeCocktailKey = 'c1';
    var cocktailKeySeq = 1;

    function cocktailKeysList() {
      return ['c1'].concat(getExtraCocktailBlocks().map(function (block) {
        return block.getAttribute('data-cocktail-key');
      }));
    }

    function cocktailLabelForKey(key) {
      return 'Cocktail n\u00b0' + (cocktailKeysList().indexOf(key) + 1);
    }

    function extraBlockForKey(key) {
      return getExtraCocktailBlocks().find(function (block) {
        return block.getAttribute('data-cocktail-key') === key;
      }) || null;
    }

    function budgetForCocktailKey(key) {
      if (key === 'c1') {
        var pack = selectedPackage();
        return Math.max(0, pack.piecesPerPerson || asNumber(piecesInput && piecesInput.value, 0));
      }
      var block = extraBlockForKey(key);
      return block ? readExtraCocktail(block).pieces : 0;
    }

    function activeCocktailBudget() {
      return budgetForCocktailKey(activeCocktailKey);
    }

    function cocktailQuantityEntries() {
      return quantityInputs.map(function (input) {
        return { input: input, context: quantityContext(input) };
      }).filter(function (entry) {
        return entry.context.isCocktail && entry.context.item;
      });
    }

    function saveActiveCocktailSelection() {
      var store = {};
      cocktailQuantityEntries().forEach(function (entry) {
        var variantId = entry.context.item.getAttribute('data-variant-id');
        var quantity = Math.max(0, Number(entry.input.value || 0));
        if (variantId && quantity > 0) store[variantId] = quantity;
      });
      cocktailSelections[activeCocktailKey] = store;
    }

    function loadCocktailSelection(key) {
      var store = cocktailSelections[key] || {};
      cocktailQuantityEntries().forEach(function (entry) {
        var variantId = entry.context.item.getAttribute('data-variant-id');
        entry.input.value = (variantId && store[variantId]) || 0;
      });
    }

    function blockForCocktailKey(key) {
      return key === 'c1' ? mainCocktailBlock : extraBlockForKey(key);
    }

    function highlightActiveCocktail() {
      cocktailKeysList().forEach(function (key) {
        var block = blockForCocktailKey(key);
        if (block) block.classList.toggle('is-cocktail-active', key === activeCocktailKey);
      });
    }

    function switchActiveCocktail(key) {
      if (cocktailKeysList().indexOf(key) === -1) return;
      if (key !== activeCocktailKey) {
        saveActiveCocktailSelection();
        activeCocktailKey = key;
        loadCocktailSelection(key);
      }
      var block = blockForCocktailKey(key);
      if (block && !block.open) block.open = true;
      highlightActiveCocktail();
      updateSummary();
    }

    function renderCocktailTabs() {
      if (!cocktailTabs) return;
      var keys = cocktailKeysList();
      var visible = keys.length > 1 && currentStep === 0;
      cocktailTabs.hidden = !visible;
      if (!visible) return;
      var usageByKey = {};
      collectAllCocktailData().forEach(function (cocktail) {
        usageByKey[cocktail.key] = cocktail.used;
      });
      cocktailTabs.innerHTML = '';
      keys.forEach(function (key) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-cocktail-tab', key);
        var budget = budgetForCocktailKey(key);
        var used = usageByKey[key] || 0;
        button.textContent = cocktailLabelForKey(key) + (budget > 0
          ? ' \u2014 ' + formatQuantity(used) + '/' + formatQuantity(budget) + ' pi\u00e8ces'
          : '');
        button.classList.toggle('is-active', key === activeCocktailKey);
        cocktailTabs.appendChild(button);
      });
    }

    function collectAllCocktailData() {
      saveActiveCocktailSelection();
      var itemsByVariant = {};
      quantityInputs.forEach(function (input) {
        var context = quantityContext(input);
        if (!context.isCocktail || !context.item) return;
        var variantId = context.item.getAttribute('data-variant-id');
        if (variantId) itemsByVariant[variantId] = context.item;
      });
      return cocktailKeysList().map(function (key, index) {
        var isMain = key === 'c1';
        var block = isMain ? null : extraBlockForKey(key);
        var extra = block ? readExtraCocktail(block) : null;
        var store = cocktailSelections[key] || {};
        var items = Object.keys(store).map(function (variantId) {
          var item = itemsByVariant[variantId];
          if (!item) return null;
          return itemDataFromElement(item, store[variantId]);
        }).filter(Boolean);
        return {
          key: key,
          number: index + 1,
          isMain: isMain,
          format: isMain ? (typeSelect ? typeSelect.value : '') : (extra ? extra.format : ''),
          pieces: budgetForCocktailKey(key),
          start: isMain ? ((startInput && startInput.value) || '') : (extra ? extra.start : ''),
          end: isMain ? ((endInput && endInput.value) || '') : (extra ? extra.end : ''),
          items: items,
          used: items.reduce(function (sum, item) { return sum + item.pieceUnits; }, 0)
        };
      });
    }

    function refreshCocktailPresetActives(block) {
      if (!block) return;
      var piecesField = block.querySelector('[data-cocktail-pieces]');
      var pieces = Math.max(0, asNumber(piecesField && piecesField.value, 0));
      Array.prototype.slice.call(block.querySelectorAll('[data-cocktail-preset]')).forEach(function (button) {
        button.classList.toggle('is-active', asNumber(button.getAttribute('data-cocktail-preset'), -1) === pieces);
      });
    }

    function addExtraCocktail() {
      if (!cocktailTemplate || !extraCocktailsContainer) return;
      extraCocktailsContainer.appendChild(cocktailTemplate.content.cloneNode(true));
      var block = extraCocktailsContainer.lastElementChild;
      var newKey = 'c' + (++cocktailKeySeq);
      block.setAttribute('data-cocktail-key', newKey);
      cocktailSelections[newKey] = {};
      renumberExtraCocktails();
      var formatSelect = block.querySelector('[data-cocktail-format]');
      populateFormatSelectFromPackages(formatSelect);
      sortFormatOptions(formatSelect);
      if (formatSelect) {
        formatSelect.addEventListener('change', function () {
          applyFormatSelection(formatSelect, block.querySelector('[data-cocktail-pieces]'));
          refreshCocktailPresetActives(block);
        });
      }
      block.addEventListener('input', function (event) {
        var data = readExtraCocktail(block);
        if (event.target && event.target.hasAttribute('data-cocktail-pieces')) {
          syncFormatToPieces(block.querySelector('[data-cocktail-format]'), data.pieces);
        }
        updateCocktailHours(block, data.start, data.end);
        refreshCocktailPresetActives(block);
        clampCocktailQuantitiesToBudget();
        updateSummary();
      });
      switchActiveCocktail(newKey);
      updateSummary();
    }

    if (addCocktailButton) addCocktailButton.addEventListener('click', addExtraCocktail);

    /* Cliquer / saisir dans un panneau cocktail le rend actif : la grille de
       pièces et la jauge basculent sur ce cocktail. */
    ['click', 'focusin'].forEach(function (eventName) {
      builder.addEventListener(eventName, function (event) {
        if (event.target.closest('[data-cocktail-remove]')) return;
        var block = event.target.closest('[data-event-cocktail]');
        if (!block) return;
        var key = block.hasAttribute('data-event-cocktail-extra')
          ? block.getAttribute('data-cocktail-key')
          : 'c1';
        if (key && key !== activeCocktailKey) switchActiveCocktail(key);
      });
    });

    builder.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-cocktail-remove]');
      if (!removeButton) return;
      var block = removeButton.closest('[data-event-cocktail-extra]');
      var removedKey = block && block.getAttribute('data-cocktail-key');
      if (block) block.remove();
      if (removedKey) {
        delete cocktailSelections[removedKey];
        if (activeCocktailKey === removedKey) {
          activeCocktailKey = 'c1';
          loadCocktailSelection('c1');
        }
      }
      renumberExtraCocktails();
      clampCocktailQuantitiesToBudget();
      updateSummary();
    });

    function updateMainCocktailHours() {
      updateCocktailHours(mainCocktailBlock, startInput ? startInput.value : '', endInput ? endInput.value : '');
      updateSummary();
    }

    [startInput, endInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', updateMainCocktailHours);
      input.addEventListener('change', updateMainCocktailHours);
    });
    [dateInput, contactInput, emailInput, phoneInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', updateSummary);
      input.addEventListener('change', updateSummary);
    });
    if (staffMealToggle) {
      staffMealToggle.addEventListener('change', function () {
        var isOn = staffMealToggle.checked;
        if (staffMealItems) {
          staffMealItems.hidden = !isOn;
          if (!isOn) {
            Array.prototype.slice.call(staffMealItems.querySelectorAll('[data-event-quantity-input]')).forEach(function (input) {
              input.value = 0;
            });
          }
        }
        updateSummary();
      });
    }
    function sortFormatOptions(select) {
      if (!select) return;
      var options = Array.prototype.slice.call(select.options).slice(1);
      options.sort(function (a, b) {
        return asNumber(a.getAttribute('data-pieces'), 0) - asNumber(b.getAttribute('data-pieces'), 0);
      });
      options.forEach(function (option) {
        select.appendChild(option);
      });
    }

    var cachedPackageFormatOptions = null;

    function populateFormatSelectFromPackages(select) {
      if (!select || !cachedPackageFormatOptions) return;
      Array.prototype.slice.call(select.options).slice(1).forEach(function (option) {
        option.remove();
      });
      cachedPackageFormatOptions.forEach(function (packageOption) {
        var option = document.createElement('option');
        var title = packageOption.getAttribute('data-title') || packageOption.textContent.trim();
        var pieces = asNumber(packageOption.getAttribute('data-pieces'), 0);
        option.value = title;
        option.textContent = /pi\u00e8ce/i.test(title) ? title : title + ' (' + formatQuantity(pieces) + ' pi\u00e8ces)';
        option.setAttribute('data-pieces', String(pieces));
        option.setAttribute('data-variant-id', packageOption.value);
        select.appendChild(option);
      });
    }

    function populateFormatSelectsFromPackages() {
      if (!packageSelect) return;
      var packageOptions = Array.prototype.slice.call(packageSelect.options).filter(function (option) {
        return option.value && asNumber(option.getAttribute('data-pieces'), 0) > 0;
      });
      if (packageOptions.length === 0) return;

      cachedPackageFormatOptions = packageOptions;
      [typeSelect].forEach(function (select) {
        if (!select) return;
        Array.prototype.slice.call(select.options).slice(1).forEach(function (option) {
          option.remove();
        });
        packageOptions.forEach(function (packageOption) {
          var option = document.createElement('option');
          var title = packageOption.getAttribute('data-title') || packageOption.textContent.trim();
          var pieces = asNumber(packageOption.getAttribute('data-pieces'), 0);
          option.value = title;
          option.textContent = /pi\u00e8ce/i.test(title) ? title : title + ' (' + formatQuantity(pieces) + ' pi\u00e8ces)';
          option.setAttribute('data-pieces', String(pieces));
          option.setAttribute('data-variant-id', packageOption.value);
          select.appendChild(option);
        });
      });
    }

    /* Sens inverse (retour Farhan) : un nombre de pièces sélectionne le format correspondant. */
    function syncFormatToPieces(select, pieces) {
      if (!select) return;
      var match = Array.prototype.slice.call(select.options).find(function (option) {
        return option.value && asNumber(option.getAttribute('data-pieces'), -1) === pieces;
      });
      select.value = match ? match.value : '';
      if (select === typeSelect && packageSelect) {
        packageSelect.value = (match && match.getAttribute('data-variant-id')) || '';
      }
    }

    function applyFormatSelection(select, targetPiecesInput) {
      var option = select.options[select.selectedIndex];
      var pieces = option ? asNumber(option.getAttribute('data-pieces'), 0) : 0;
      if (targetPiecesInput && pieces > 0) targetPiecesInput.value = pieces;
      if (select === typeSelect && packageSelect) {
        packageSelect.value = (option && option.getAttribute('data-variant-id')) || '';
      }
      clampCocktailQuantitiesToBudget();
      updateSummary();
      if (select === typeSelect && currentStep === 2) updateStaffingSuggestions();
    }

    populateFormatSelectsFromPackages();
    sortFormatOptions(typeSelect);
    highlightActiveCocktail();

    if (typeSelect) {
      typeSelect.addEventListener('change', function () {
        applyFormatSelection(typeSelect, piecesInput);
      });
    }
    if (piecesInput) {
      var handleManualPieces = function () {
        syncFormatToPieces(typeSelect, Math.max(0, asNumber(piecesInput.value, 0)));
        clampCocktailQuantitiesToBudget();
        updateSummary();
      };
      piecesInput.addEventListener('change', handleManualPieces);
      piecesInput.addEventListener('input', handleManualPieces);
    }
    if (packageSelect) {
      packageSelect.addEventListener('change', function () {
        var pack = selectedPackage();
        if (piecesInput && pack.piecesPerPerson > 0) {
          piecesInput.value = pack.piecesPerPerson;
        }
        clampCocktailQuantitiesToBudget();
        updateSummary();
      });
    }

    salleAnswerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setSalleChoice(button.getAttribute('data-event-salle-answer'));
      });
    });

    if (salleChangeButton) {
      salleChangeButton.addEventListener('click', function () {
        setSalleChoice(null);
      });
    }

    var errorsPanel = builder.querySelector('[data-event-errors]');
    var errorsList = builder.querySelector('[data-event-errors-list]');
    var errorsTitle = builder.querySelector('[data-event-errors-title]');

    /*
      Source unique de ce qui bloque une demande. Chaque problème porte son
      libellé, l'étape où le corriger et le champ à focaliser : ajouter une
      règle ne touche que cette fonction. `upToStep` limite la vérification aux
      étapes déjà traversées, pour ne pas reprocher à l'étape 1 ce qui se
      remplit à l'étape 4.
    */
    function collectBuilderIssues(context) {
      var upTo = typeof context.upToStep === 'number' ? context.upToStep : finalStep;
      var cocktails = context.cocktails || collectAllCocktailData();
      var issues = [];

      function add(step, label, field, cocktailKey, fields) {
        if (step > upTo) return;
        issues.push({
          step: step,
          label: label,
          field: field || null,
          fields: fields || (field ? [field] : []),
          cocktailKey: cocktailKey || null
        });
      }

      /* Étape 1 — cocktails : format, budget de pièces exact, horaires. */
      cocktails.forEach(function (cocktail) {
        var name = cocktailLabelForKey(cocktail.key);
        var block = blockForCocktailKey(cocktail.key);
        var formatField = block && block.querySelector('[data-event-type], [data-cocktail-format]');
        var piecesField = block && block.querySelector('[data-event-pieces-per-person], [data-cocktail-pieces]');
        var startField = block && block.querySelector('[data-event-start], [data-cocktail-start]');
        var endField = block && block.querySelector('[data-event-end], [data-cocktail-end]');

        if (cocktail.pieces <= 0) {
          add(0, name + ' : choisissez un format (ou un nombre de pièces).', formatField || piecesField, cocktail.key, [formatField, piecesField]);
        } else if (cocktail.used < cocktail.pieces) {
          add(0, name + ' : il reste ' + pieceLabel(cocktail.pieces - cocktail.used) + ' à choisir sur ' + pieceLabel(cocktail.pieces) + '.', piecesField || formatField, cocktail.key, [block]);
        } else if (cocktail.used > cocktail.pieces) {
          add(0, name + ' : ' + pieceLabel(cocktail.used - cocktail.pieces) + ' de trop par rapport au format choisi.', piecesField || formatField, cocktail.key, [block]);
        }

        if (!cocktail.start || !cocktail.end) {
          var missingTimeFields = [];
          if (!cocktail.start) missingTimeFields.push(startField);
          if (!cocktail.end) missingTimeFields.push(endField);
          add(0, name + " : renseignez l'heure d'arrivée et de départ des convives.", !cocktail.start ? startField : endField, cocktail.key, missingTimeFields);
        }
      });

      /* Étape 2 — salle. */
      if (!salleChoice) {
        add(1, 'Indiquez si vous souhaitez louer une salle.', builder.querySelector('[data-event-salle-answer="yes"]'), null, [salleGate]);
      }

      /* Étape 4 — récapitulatif : contenu, date, coordonnées. */
      if (typeof context.itemCount === 'number' && context.itemCount === 0) {
        add(finalStep, 'Votre sélection est vide : ajoutez au moins un article.', null);
      }
      if (!dateInput || !dateInput.value) {
        add(finalStep, 'Choisissez la date de votre événement.', dateInput);
      } else if (!hasMinimumLeadTime(dateInput.value, startInput && startInput.value, MINIMUM_LEAD_TIME_HOURS)) {
        add(finalStep, 'La date doit être au moins 48 h après aujourd’hui.', dateInput);
      }
      if (contactInput && !contactInput.value.trim()) {
        add(finalStep, 'Indiquez votre nom.', contactInput);
      }
      if (emailInput && !emailInput.value.trim()) {
        add(finalStep, 'Indiquez votre e-mail pour recevoir la réponse.', emailInput);
      } else if (emailInput && emailInput.value.indexOf('@') === -1) {
        add(finalStep, "L'adresse e-mail saisie n'est pas valide.", emailInput);
      }
      if (!requestUrl) {
        add(finalStep, "Le formulaire de demande n'est pas connecté : contactez l'équipe Becchi.", null);
      }

      return issues;
    }

    function clearInlineBuilderValidation() {
      Array.prototype.slice.call(builder.querySelectorAll('[data-event-inline-invalid]')).forEach(function (element) {
        element.classList.remove('is-invalid');
        element.removeAttribute('data-event-inline-invalid');
      });
      Array.prototype.slice.call(builder.querySelectorAll('[data-event-inline-invalid-control]')).forEach(function (control) {
        control.removeAttribute('aria-invalid');
        control.removeAttribute('data-event-inline-invalid-control');
      });
    }

    function validationContainer(field) {
      if (!field) return null;
      if (field.matches && field.matches('[data-event-salle-answer]')) {
        return salleGate || field.closest('.event-builder__salle-gate') || field;
      }
      if (field.matches && field.matches('input, select, textarea')) {
        return field.closest('.event-builder__field') || field;
      }
      return field;
    }

    function markInlineValidationField(field) {
      var container = validationContainer(field);
      if (!container) return;
      container.classList.add('is-invalid');
      container.setAttribute('data-event-inline-invalid', 'true');
      var controls = field.matches && field.matches('input, select, textarea') ? [field] : [];
      controls.forEach(function (control) {
        control.setAttribute('aria-invalid', 'true');
        control.setAttribute('data-event-inline-invalid-control', 'true');
      });
    }

    function applyInlineBuilderValidation(issues, upToStep) {
      clearInlineBuilderValidation();
      inlineValidationUpToStep = typeof upToStep === 'number' ? upToStep : inlineValidationUpToStep;
      issues.forEach(function (issue) {
        (issue.fields || []).forEach(markInlineValidationField);
      });
    }

    function resetInlineBuilderValidation() {
      inlineValidationUpToStep = null;
      clearInlineBuilderValidation();
    }

    function refreshInlineBuilderValidation() {
      if (inlineValidationUpToStep === null) return;
      var summary = computeSummary();
      var cocktails = collectAllCocktailData();
      var nonCocktailItems = summary.items.filter(function (item) { return !item.isCocktail; });
      var itemCount = cocktails.reduce(function (count, cocktail) {
        return count + cocktail.items.length;
      }, 0) + nonCocktailItems.length;
      var issues = collectBuilderIssues({
        upToStep: inlineValidationUpToStep,
        cocktails: cocktails,
        summary: summary,
        itemCount: inlineValidationUpToStep === finalStep ? itemCount : undefined
      });
      applyInlineBuilderValidation(issues, inlineValidationUpToStep);
    }

    function closeBuilderIssues() {
      if (!errorsPanel) return;
      errorsPanel.hidden = true;
      document.body.classList.remove('event-builder-errors-open');
    }

    function showBuilderIssues(issues) {
      if (!errorsPanel || !errorsList) return;
      errorsList.innerHTML = '';
      issues.forEach(function (issue) {
        var li = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'event-builder__errors-item';
        button.textContent = issue.label;
        button.addEventListener('click', function () {
          closeBuilderIssues();
          if (issue.cocktailKey) switchActiveCocktail(issue.cocktailKey);
          setBuilderStep(issue.step, true);
          if (issue.field) {
            var block = issue.field.closest('details');
            if (block && !block.open) block.open = true;
            issue.field.focus({ preventScroll: true });
            issue.field.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
        li.appendChild(button);
        errorsList.appendChild(li);
      });
      if (errorsTitle) {
        errorsTitle.textContent = issues.length === 1
          ? 'Il reste un point à compléter'
          : 'Il reste ' + issues.length + ' points à compléter';
      }
      errorsPanel.hidden = false;
      document.body.classList.add('event-builder-errors-open');
      var dialog = errorsPanel.querySelector('.event-builder__errors-dialog');
      if (dialog) dialog.focus({ preventScroll: true });
    }

    if (errorsPanel) {
      errorsPanel.addEventListener('click', function (event) {
        if (event.target.closest('[data-event-errors-close]')) closeBuilderIssues();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !errorsPanel.hidden) closeBuilderIssues();
      });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var summary = computeSummary();
        var items = summary.items;
        var pack = summary.pack;
        var guests = summary.guests;

        var allCocktails = collectAllCocktailData();

        if (currentStep < finalStep) {
          var stepIssues = collectBuilderIssues({ upToStep: currentStep, cocktails: allCocktails, summary: summary });
          if (stepIssues.length > 0) {
            applyInlineBuilderValidation(stepIssues, currentStep);
            showBuilderIssues(stepIssues);
            return;
          }
          resetInlineBuilderValidation();
          setBuilderStep(currentStep + 1, true);
          return;
        }

        var nonCocktailItems = items.filter(function (item) { return !item.isCocktail; });
        var payloadItems = [];
        allCocktails.forEach(function (cocktail) {
          cocktail.items.forEach(function (item) {
            var withNumber = Object.assign({}, item);
            withNumber.cocktailNumber = cocktail.number;
            payloadItems.push(withNumber);
          });
        });
        payloadItems = payloadItems.concat(nonCocktailItems);
        var allCocktailsBudget = allCocktails.reduce(function (sum, cocktail) { return sum + cocktail.pieces; }, 0);
        var allCocktailsUsed = allCocktails.reduce(function (sum, cocktail) { return sum + cocktail.used; }, 0);

        /*
          Retour client : tous les blocages sont présentés d'un coup, dans une
          fenêtre lisible, au lieu d'un message à la fois en bas de page.
        */
        var issues = collectBuilderIssues({
          upToStep: finalStep,
          cocktails: allCocktails,
          summary: summary,
          itemCount: payloadItems.length
        });
        if (issues.length > 0) {
          applyInlineBuilderValidation(issues, finalStep);
          showBuilderIssues(issues);
          return;
        }

        var payload = {
          source: 'becchi_shopify_compose_evenement',
          event: {
            format: typeSelect ? typeSelect.value : '',
            guests: guests,
            date: dateInput ? dateInput.value : '',
            start_time: startInput ? startInput.value : '',
            end_time: endInput ? endInput.value : '',
            pieces_per_person: budgetForCocktailKey('c1'),
            pieces_total: allCocktailsBudget,
            pieces_selected: allCocktailsUsed,
            additional_cocktails: allCocktails.filter(function (cocktail) {
              return !cocktail.isMain;
            }).map(function (cocktail) {
              return {
                format: cocktail.format,
                pieces_per_person: cocktail.pieces,
                start_time: cocktail.start,
                end_time: cocktail.end,
                items: cocktail.items.map(function (item) {
                  return { title: item.title, quantity: item.quantity, piece_units: item.pieceUnits };
                })
              };
            })
          },
          contact: {
            name: contactInput ? contactInput.value : '',
            email: emailInput ? emailInput.value : '',
            phone: phoneInput ? phoneInput.value : ''
          },
          /*
            Contrat serveur (compose-request) : clés snake_case, et seuls
            boutique_id + title sont lus — le serveur re-tarifie la formule
            depuis la base, jamais depuis les montants envoyés par le client.
          */
          package: {
            boutique_id: pack.boutiqueId,
            title: pack.title
          },
          items: payloadItems.map(function (item) {
            var itemMoney = lineMoney(item);
            return {
              cocktail_number: item.cocktailNumber || null,
              title: item.title,
              quantity: item.quantity,
              group: item.group,
              element_type: item.elementType,
              boutique_id: item.boutiqueId,
              element_id: item.elementId,
              variant_id: item.variantId,
              unit_price_cents: item.price,
              unit_ht_cents: item.unitHtCents,
              unit_ttc_cents: item.unitTtcCents,
              tva_rate: item.tvaRate,
              line_ht_cents: itemMoney.ht,
              line_tva_cents: itemMoney.tva,
              line_ttc_cents: itemMoney.ttc,
              quote_only: item.quoteOnly,
              is_cocktail: item.isCocktail,
              piece_equivalent: item.pieceEquivalent,
              piece_units: item.pieceUnits
            };
          }),
          totals: {
            package_cents: summary.packageMoney.ttc,
            addons_cents: summary.addonsMoney.ttc,
            ht_cents: summary.totalMoney.ht,
            tva_cents: summary.totalMoney.tva,
            estimated_cents: summary.totalMoney.ttc
          }
        };

        addButton.disabled = true;
        if (previousButton) previousButton.disabled = true;
        addButton.classList.add('is-loading');
        if (message) {
          message.textContent = 'Envoi de la demande...';
          message.dataset.tone = 'info';
        }

        fetch(requestUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('request_failed');
            return response.text();
          })
          .then(function () {
            resetSelectionAfterSend();
            if (message) {
              message.textContent = 'Demande envoyée. L’équipe Becchi revient vers vous rapidement.';
              message.dataset.tone = 'success';
            }
            showCartToast('Demande envoyée.', 'success');
          })
          .catch(function () {
            if (message) {
              message.textContent = "Impossible d'envoyer cette demande pour le moment.";
              message.dataset.tone = 'error';
            }
          })
          .finally(function () {
            addButton.disabled = false;
            addButton.classList.remove('is-loading');
            if (previousButton) previousButton.disabled = currentStep === 0;
          });
      });
    }

    updateSummary();
    setBuilderStep(0, false);
  });

  var productModal = document.querySelector('[data-corporate-product-modal]');
  if (productModal) {
    var modalDialog = productModal.querySelector('.corporate-product-modal__dialog');
    var modalMain = productModal.querySelector('[data-corporate-modal-main]');
    var modalUpsells = productModal.querySelector('[data-corporate-modal-upsells]');
    var modalUpsellsSection = productModal.querySelector('[data-corporate-modal-upsells-section]');
    var modalMessage = productModal.querySelector('[data-corporate-modal-message]');
    var lastModalTrigger = null;

    function uniqueProductTemplates() {
      var seen = {};
      return Array.prototype.slice.call(document.querySelectorAll('[data-corporate-product-template]')).filter(function (template) {
        var id = template.getAttribute('data-product-id');
        if (!id || seen[id]) return false;
        seen[id] = true;
        return true;
      });
    }

    function findProductTemplate(productId, trigger) {
      var card = trigger && trigger.closest('[data-product-card]');
      var scopedTemplate = card && card.querySelector('[data-corporate-product-template]');
      if (scopedTemplate) return scopedTemplate;
      return uniqueProductTemplates().filter(function (template) {
        return template.getAttribute('data-product-id') === productId;
      })[0];
    }

    function templateClone(template, selector) {
      var node = template && template.content && template.content.querySelector(selector);
      return node ? node.cloneNode(true) : null;
    }

    function showModalMessage(text, tone) {
      if (!modalMessage) return;
      modalMessage.textContent = text || '';
      modalMessage.dataset.tone = tone || '';
      modalMessage.classList.toggle('is-visible', Boolean(text));
    }

    function updateCartCount() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('cart');
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (counter) {
            counter.textContent = cart.item_count;
          });
        });
    }

    function closeProductModal() {
      productModal.classList.remove('is-open');
      document.body.classList.remove('corporate-product-modal-open');
      window.setTimeout(function () {
        productModal.hidden = true;
        if (modalMain) modalMain.innerHTML = '';
        if (modalUpsells) modalUpsells.innerHTML = '';
        showModalMessage('', '');
      }, 180);
      if (lastModalTrigger) lastModalTrigger.focus({ preventScroll: true });
    }

    function openProductModal(productId, trigger) {
      var template = findProductTemplate(productId, trigger);
      var main = templateClone(template, '[data-corporate-template-main]');
      if (!main || !modalMain || !modalUpsells) return false;

      lastModalTrigger = trigger;
      modalMain.innerHTML = '';
      modalUpsells.innerHTML = '';
      modalMain.appendChild(main);

      /*
        Retour client : la description reste dans la colonne principale, sous le
        nom du produit (la bande verticale de droite a été supprimée). L'extrait
        ferait doublon dès qu'une vraie description existe.
      */
      var descriptionNode = main.querySelector('.corporate-product-template__description');
      var excerptNode = main.querySelector('.corporate-product-template__excerpt');
      if (descriptionNode && excerptNode) excerptNode.remove();

      /* Upsells non alimentaires uniquement (retour client) : couverts, nappage… */
      uniqueProductTemplates().filter(function (candidate) {
        if (candidate.getAttribute('data-product-id') === productId) return false;
        var hostCard = candidate.closest('[data-product-card]');
        return Boolean(hostCard) && productMatchesCorporateFilter(hostCard, 'upsell-non-food');
      }).slice(0, 5).forEach(function (candidate) {
        var upsell = templateClone(candidate, '[data-corporate-template-upsell]');
        if (upsell) modalUpsells.appendChild(upsell);
      });

      if (modalUpsellsSection) modalUpsellsSection.hidden = modalUpsells.children.length === 0;

      productModal.hidden = false;
      requestAnimationFrame(function () {
        productModal.classList.add('is-open');
        document.body.classList.add('corporate-product-modal-open');
        if (modalDialog) modalDialog.focus({ preventScroll: true });
      });
      return true;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-corporate-product-open]');
      if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var productId = trigger.getAttribute('data-product-id');
      if (!productId) return;
      if (openProductModal(productId, trigger)) event.preventDefault();
    });

    productModal.addEventListener('click', function (event) {
      if (event.target.closest('[data-corporate-modal-close]')) {
        event.preventDefault();
        closeProductModal();
        return;
      }

      var minus = event.target.closest('[data-quantity-minus]');
      var plus = event.target.closest('[data-quantity-plus]');
      if (minus || plus) {
        var control = event.target.closest('[data-quantity-control]');
        var input = control && control.querySelector('input[type="number"]');
        if (!input) return;
        event.preventDefault();
        input.value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    productModal.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-corporate-modal-form]');
      if (!form) return;
      event.preventDefault();

      var submit = form.querySelector('[data-corporate-modal-form-submit]');
      var wasDisabled = submit ? submit.disabled : false;
      var defaultContent = submit ? submit.innerHTML : '';
      if (submit) {
        submit.disabled = true;
        submit.classList.add('is-loading');
      }
      showModalMessage('Ajout au panier...', 'info');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (error) { throw error; });
          return response.json();
        })
        .then(function () {
          closeProductModal();
          showCartToast('Article ajouté au panier.', 'success');
          return updateCartCount().catch(function () {});
        })
        .catch(function () {
          showModalMessage("Impossible d'ajouter ce produit pour le moment.", 'error');
        })
        .finally(function () {
          if (submit) {
            submit.disabled = wasDisabled;
            submit.classList.remove('is-loading');
            if (defaultContent) submit.innerHTML = defaultContent;
          }
        });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !productModal.hidden) closeProductModal();
    });
  }

  var popup = document.querySelector('[data-newsletter-popup]');
  if (popup && window.localStorage && localStorage.getItem('newsletter-popup-closed') !== 'true') {
    window.setTimeout(function () {
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
        document.body.classList.add('newsletter-open');
      });
    }, 10000);

    popup.querySelectorAll('[data-newsletter-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        popup.classList.remove('is-open');
        document.body.classList.remove('newsletter-open');
        localStorage.setItem('newsletter-popup-closed', 'true');
        window.setTimeout(function () {
          popup.hidden = true;
        }, 250);
      });
    });
  }
})();
